/* eslint-disable react/display-name */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import React from 'react';
import { useTranslation } from 'react-i18next';

import SpotCheckChart from '../../../charts/SpotCheckChart';
import useReportQueryParams from 'components/ReportsModule/hooks/use-report-query-params';
import ReportCard from 'components/ReportsModule/components/common/ReportCard';
import { KeyClassroomEngagementStudentResult } from 'types/schema-generated-types';
import { ReportEntityType } from 'components/ReportsModule/types';

const ClassroomSpotCheckChartCard: React.FC<{
  reportData: KeyClassroomEngagementStudentResult[];
  loading: boolean;
}> = ({ reportData = [], loading }) => {
  const { t } = useTranslation(['Reports', 'ReportsHelpCharts']);
  const [, setQuery] = useReportQueryParams();

  const { studentNames, ids, wpmSeries, accuracySeries } = reportData.reduce(
    (acc, { student, spotChecks }) => {
      if (!student) return acc;
      const { studentNames, ...stats } = acc;

      studentNames.push(`${student.firstName} ${student.lastName}`);
      stats.ids.push(student.id);
      stats.wpmSeries.push(spotChecks?.averageWpm ?? 0);
      stats.accuracySeries.push(spotChecks?.averageAccuracy ?? 0);
      return acc;
    },
    {
      ids: [] as number[],
      studentNames: [] as string[],
      wpmSeries: [] as number[],
      accuracySeries: [] as number[]
    }
  );

  const handleChartClick = (index: number) => {
    setQuery({ entityType: ReportEntityType.STUDENT, entityId: ids[index] }, 'pushIn');
  };

  return (
    <ReportCard
      title={t('Spot Checks')}
      helpText={t('spotChecks', { ns: 'ReportsHelpCharts' })}
      loading={loading}
      reportData={reportData}
      reportDataProp="spotChecks"
    >
      <SpotCheckChart
        wpmSeries={wpmSeries}
        accuracySeries={accuracySeries}
        labels={studentNames}
        onClick={handleChartClick}
      />
    </ReportCard>
  );
};

export default ClassroomSpotCheckChartCard;
